// Pantalla `command="logout-confirm"`. Auto-submit del form al montar.
// Si tras 2s seguimos visibles (no hubo redirect), mostrar el form
// completo para que el usuario decida. El timer está en Login.tsx
// (useEffect); esta pantalla sólo renderiza el form. "Volver" hace
// history.back() en una ventana normal y window.close() en un popup.

import type { FormEvent } from "react";
import type { KcData } from "../kcData";
import { PopupAwareBackButton } from "../components/PopupAwareBackButton";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

export interface LogoutConfirmPageProps {
  data: KcData;
  running: boolean;
  showLogoutConfirmForm: boolean;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export function LogoutConfirmPage(props: LogoutConfirmPageProps) {
  const { data, running, showLogoutConfirmForm, onSubmit } = props;
  const formDisplay = showLogoutConfirmForm ? "block" : "none";
  const sessionCode = (data.form?.logoutConfirmCode as string | undefined) ?? "";

  return (
    <StandardPage page="logout-confirm" data={data}>
      <div>
        <p className="instruction">
          {showLogoutConfirmForm
            ? msg("logoutConfirmInstruction")
            : msg("logoutInProgress")}
        </p>
        <form
          id="kc-logout-confirm"
          action={data.url!.logoutConfirmAction}
          method="post"
          onSubmit={onSubmit}
          style={{ display: formDisplay }}
        >
          <input type="hidden" name="session_code" value={sessionCode} />
          <input type="hidden" name="confirmLogout" value="Logout" />
          <button
            type="submit"
            className="btn btn-lg btn-block btn-primary"
            disabled={running}
          >
            {msg("doLogout")}
          </button>
        </form>
        {showLogoutConfirmForm ? (
          <p style={{ marginTop: "50px" }}>
            <PopupAwareBackButton onClick={() => history.back()} />
          </p>
        ) : null}
      </div>
    </StandardPage>
  );
}
